module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "toolbar-tabs"
  }, [_c('div', {
    staticClass: "bar bar-2",
    on: {
      "click": function($event) {
        _vm.kefu = true
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.qrCode) ? _c('div', {
    staticClass: "app-qr-code",
    on: {
      "mouseenter": function($event) {
        _vm.qrCode = true
      },
      "mouseleave": function($event) {
        _vm.qrCode = false
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.kefu) ? _c('div', {
    staticClass: "lianxifangshi",
    on: {
      "mouseenter": function($event) {
        _vm.kefu = true
      },
      "mouseleave": function($event) {
        _vm.kefu = false
      }
    }
  }, [_vm._m(2)]) : _vm._e()]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar bar-5"
  }, [_c('a', {
    staticClass: "to-top",
    attrs: {
      "href": "#app"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "overflow": "hidden",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "app-code code1"
  }, [_c('p', [_vm._v("订阅号")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./assets/images/订阅号.jpg"),
      "width": "97"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "app-code code2"
  }, [_c('p', [_vm._v("订阅号")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./assets/images/服务号.jpg"),
      "width": "97"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "2px",
      "background-color": "#f28d01"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "width": "20px",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("./assets/images/tel.png")
    }
  }), _vm._v(" "), _c('i'), _vm._v("010-62311360")]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_c('img', {
    staticStyle: {
      "height": "20px",
      "width": "20px",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("./assets/images/email.png")
    }
  }), _c('i'), _vm._v("kefu@jdtax.cn")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode",
    staticStyle: {
      "width": "130px",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "imgbox",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/订阅号275x275.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "imgbox"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/客服微信二维码.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("微信客服")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-40699032"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 257
// module chunks = 99